'use client'

import { GoogleMap } from '@react-google-maps/api'
import { IMarker, IRawMarker, kmToMiles } from '@repo/sdk'
import { cn } from '@repo/ui/lib'
import { RefObject, useImperativeHandle, useRef } from 'react'

import { useMapContext } from './context.tsx'
import { darkStyle } from './dark-style.ts'
import { Directions } from './directions.tsx'
import { Markers } from './markers.tsx'

interface IProps {
  className?: string
  ref: RefObject<unknown>
}

export const DarkMap = ({ className, ref }: IProps) => {
  const {
    estimatedTrip,
    fitBounds,
    map,
    onLoad,
    onUnmount,
    route,
    setMarkerList,
    setRoute,
    showEstimatedTrip,
  } = useMapContext()
  const refMap = useRef<HTMLDivElement>(null)

  useImperativeHandle(ref, () => ({
    async updateMarker(rawMarkers: IRawMarker[]) {
      const markers = rawMarkers.filter(marker => marker.lat && marker.lng) as IMarker[]
      if (markers[0] && map) {
        setMarkerList(markers)
        fitBounds(markers, map)
      }
    },
    async updateRoute(newRoute: string[]) {
      if (newRoute[0] && (newRoute?.join() !== route?.join() || !route[0])) {
        setRoute(newRoute)
      }
    },
  }))

  return (
    <div className={cn('h-full w-full', className)}>
      <div className={cn('relative top-0 h-full w-full rounded')} ref={refMap}>
        <GoogleMap
          mapContainerStyle={{ height: '100%', width: '100%' }}
          onLoad={onLoad}
          onUnmount={onUnmount}
          options={{
            fullscreenControl: false,
            mapTypeControl: false,
            minZoom: 3,
            streetViewControl: false,
            styles: darkStyle,
          }}
          zoom={6}
        >
          <Directions />
          <Markers />
        </GoogleMap>
      </div>
      {showEstimatedTrip && estimatedTrip && (
        <>
          <p className="my-4 mr-auto text-sm font-medium text-gray-700">
            Estimated trip:{' '}
            <label className="ml-2 text-base font-semibold text-gray-800">
              {kmToMiles(estimatedTrip / 1000)} miles
            </label>
          </p>
          <hr className="w-full" />
        </>
      )}
    </div>
  )
}
